import { render, staticRenderFns } from "./verificationPoList.vue?vue&type=template&id=39207650&scoped=true&"
import script from "./verificationPoList.vue?vue&type=script&lang=js&"
export * from "./verificationPoList.vue?vue&type=script&lang=js&"
import style0 from "./verificationPoList.vue?vue&type=style&index=0&id=39207650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39207650",
  null
  
)

export default component.exports